<template>
  <div class="sns-button-with-title">
    <slot />
    <span class="sns-button-with-title__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sns-button-with-title {
  display: grid;
  gap: 4px;

  &__title {
    @extend %minimal;
    display: inline-block;
  }
}
</style>
